















import { Vue, Component, Mixins } from "vue-property-decorator";
import { Mobile } from "@/mixins/mobile";

export default class AccordionSection extends Mixins(Mobile) {}
